import { render, staticRenderFns } from "./free-lessons.vue?vue&type=template&id=396df8c2"
import script from "./free-lessons.vue?vue&type=script&lang=js"
export * from "./free-lessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TfImg: require('/usr/src/app/components/tf/img.vue').default,GridDynamic: require('/usr/src/app/components/grid/dynamic.vue').default})
